import {
  type UseSuspenseQueryResult,
  useSuspenseQuery,
} from '@tanstack/react-query';

import api from '@/axios';
import { GET_PURCHASE_ORDERS_KEY } from '@/keys';
import type { Paginated } from '@/types/core/paginated';
import type { PurchaseOrder } from '@/types/core/purchase-order/purchase-order';
import type { DataTableQueryVariables } from '@/types/data-table';

export const getPurchaseOrders = async ({
  page,
  perPage,
  sort,
  filters,
}: DataTableQueryVariables<PurchaseOrder>): Promise<
  Paginated<PurchaseOrder>
> => {
  const response = await api.get<Paginated<PurchaseOrder>>('/purchase-orders', {
    params: {
      page,
      perPage,
      sort: JSON.stringify(sort),
      filters: JSON.stringify(filters),
    },
  });
  return response.data;
};

export const useGetPurchaseOrders = ({
  page,
  perPage,
  sort,
  filters,
}: DataTableQueryVariables<PurchaseOrder>): UseSuspenseQueryResult<
  Paginated<PurchaseOrder>,
  Error
> =>
  useSuspenseQuery({
    queryKey: [...GET_PURCHASE_ORDERS_KEY, page, perPage, sort, filters],
    queryFn: () =>
      getPurchaseOrders({
        page,
        perPage,
        sort,
        filters,
      }),
  });
